<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "AUX IP Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current AUX IP config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Aux IP Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th>
                  {{ title.ipAddr }}
                </th>
                <th>
                  {{ title.ipMask }}
                </th>
                <th>
                  {{ title.ipStatus }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in auxipTable"
                :key="index"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.ipAddr }}</div>
                </td>
                <td>
                  <div>{{ row.ipMask }}</div>
                </td>
                <td>
                  <div>{{ row.ipStatus }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Aux IP Edit'"
              @close="isShowAddTable = false"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="ipaddr">{{
                    title.ipAddr
                  }}</label>
                  <div
                    class="col-sm-5"
                    :class="{ 'has-error': input_para_check(1) }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="ipaddr"
                      maxlength="15"
                      :disabled="isEditClik"
                      v-model="auxipForm.ipAddr"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: input_para_check(1) ? 'block' : 'none',
                      }"
                      >{{ input_para_check(1) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="ipmask">{{
                    title.ipMask
                  }}</label>
                  <div
                    class="col-sm-5"
                    :class="{ 'has-error': input_para_check(2) }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="ipmask"
                      maxlength="15"
                      v-model="auxipForm.ipMask"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: input_para_check(2) ? 'block' : 'none',
                      }"
                      >{{ input_para_check(2) }}
                    </small>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>


<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"

export default {
  name: "auxIp",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      auxipForm: {
        ipAddr: "",
        ipMask: "",
      },

      auxipTable: [],
    }
  },

  created() {
    this.loadAuxIpInfo()
  },

  methods: {
    loadAuxIpInfo() {
      get("auxipinfo")
        .then((res) => {
          this.auxipTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        ipAddr: "",
        ipMask: "",
      }

      this.auxipForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkApply() {
      var newProfile = {
        ipAddr: this.auxipForm.ipAddr,
        ipMask: this.auxipForm.ipMask,
        operate: 1,
      }

    var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      post("auxipinfo", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadAuxIpInfo()
            /*if (this.isEditClik) {
              let editindex = this.select[0]
              this.auxipTable[editindex]= newProfile
            }
            else
            {
              this.auxipTable.push(newProfile)
              this.auxipTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.auxipTable.length; i++) {
        if (this.auxipTable[i].selected) {
          this.auxipForm.username = this.auxipTable[i].username
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        ipAddr: "",
        ipMask: "",
        operate: 2,
      }
      var deleteAll = true;

      this.auxipTable.forEach(element =>{
          if(!element.selected)
            deleteAll = false
      })

      if(deleteAll)
      {
        this.showAlertBox("warn", "Message", "It is not allowed to delete all of aux ip address, please reserve one at least.")
        return
      }
      
      for (i = 0; i < this.auxipTable.length; i++) {
        if (this.auxipTable[i].selected) {
          newProfile.ipAddr = this.auxipTable[i].ipAddr
          newProfile.ipMask = this.auxipTable[i].ipMask
          del.push(post("auxipinfo", newProfile))
          id.push(this.auxipTable[i].ipAddr)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.auxipTable.length; i++) {
                if (this.auxipTable[i].ipAddr == id[index]) {
                  this.auxipTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.auxipTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.auxipTable[i], "selected", true)
        } else {
          this.$set(this.auxipTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value) {
      if (value == 1 || value == 0) {
        if (this.auxipForm.ipAddr != "") {
          if (
            this.auxipForm.ipAddr.match(/[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) ==
            null
          ) {
            return "ip address must be inputted with A.B.C.D "
          } else {
            var id = this.auxipForm.ipAddr.split(".")
            let ip0 = Number(id[0])
            let ip1 = Number(id[1])
            let ip2 = Number(id[2])
            let ip3 = Number(id[3])
            if (
              ip0 < 0 ||
              ip0 > 255 ||
              ip1 < 0 ||
              ip1 > 255 ||
              ip2 < 0 ||
              ip2 > 255 ||
              ip3 < 0 ||
              ip3 > 255
            )
              return "invalid ip address"
          }
        }
      }

      if (value == 2 || value == 0) {
        if (this.auxipForm.ipMask != "") {
          if (
            this.auxipForm.ipMask.match(/[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) ==
            null
          ) {
            return "ip mask must be inputted with A.B.C.D "
          } else {
            var id = this.auxipForm.ipMask.split(".")
            let ip0 = Number(id[0])
            let ip1 = Number(id[1])
            let ip2 = Number(id[2])
            let ip3 = Number(id[3])
            if (
              ip0 < 0 ||
              ip0 > 255 ||
              ip1 < 0 ||
              ip1 > 255 ||
              ip2 < 0 ||
              ip2 > 255 ||
              ip3 < 0 ||
              ip3 > 255
            )
              return "invalid ip mask"
          }
        }
      }

      return null
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>